export const rotaBibliotecaGali = [
  {
    path: "/biblioteca",
    name: "Biblioteca Gali",
    component: () => import("@/views/Biblioteca/BibliotecaGali.vue"),
    meta: {
      title: "Biblioteca",
      subject: ["BIBLIOTECA"],
      icon: "mdi-bookshelf",
      showMenu: true,
    },
  },
];

export const rotaBibliotecaObra = [
  {
    path: "biblioteca",
    name: "Biblioteca De Obra",
    component: () => import("@/views/Biblioteca/BibliotecaObra.vue"),
    meta: {
      breadcrumb: "Dashboard",
      title: "Biblioteca de Obra",
      subject: ["BIBLIOTECA"],
      action: ["read"],
      icon: "mdi-bookshelf",
      showMenu: true,
    },
  },
];
